export default defineNuxtRouteMiddleware(async () => {
  const { $gtag, isHydrating } = useNuxtApp();
  if (!isHydrating) {
    $gtag?.reset();
  }
});
